export const LEAD_IMPORT_REQUEST = 'LEAD_IMPORT_REQUEST';
export const LEAD_IMPORT = 'LEAD_IMPORT';

export const LEAD_MANUAL_PUSH_REQUEST = 'LEAD_MANUAL_PUSH_REQUEST';
export const LEAD_MANUAL_PUSH = 'LEAD_MANUAL_PUSH';
